import { render, staticRenderFns } from "./TxSearchForm.vue?vue&type=template&id=ab20dbe2&scoped=true&"
import script from "./TxSearchForm.vue?vue&type=script&lang=js&"
export * from "./TxSearchForm.vue?vue&type=script&lang=js&"
import style0 from "./TxSearchForm.vue?vue&type=style&index=0&id=ab20dbe2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab20dbe2",
  null
  
)

export default component.exports